/*
  Kleurbolletjes op productkaarten (snippets/kleur-swatches.liquid).
  Hover (desktop) of tik (mobiel) op een bolletje: kaartfoto en kaartlinks
  (?variant=) gaan naar de goedkoopste variant met een eigen foto in die kleur.
  Alles komt uit data-attributen, geen fetch.
  Werkt met delegatie, dus ook voor kaarten die later in de DOM komen
  (filters, oneindig scrollen, recent bekeken).
*/
(() => {
  if (window.__kleurSwatches) return;
  window.__kleurSwatches = true;

  const IMG_SELECTOR =
    'img.product-image:not(.product-image--modal-filter), .pdp-upsell-products__image img, .product-image-wrapper img:not([src*="cart.svg"])';
  const canHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Kleinste voorouder die de kaartfoto bevat = de kaart.
  function cardScope(swatch) {
    let el = swatch.parentElement;
    while (el && el !== document.body) {
      if (el.querySelector(IMG_SELECTOR)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function sameProduct(href, productPath) {
    try {
      return new URL(href, location.origin).pathname === productPath;
    } catch (e) {
      return false;
    }
  }

  function activate(swatch) {
    const group = swatch.closest('[data-kleur-swatches]');
    if (!group) return;
    const scope = cardScope(swatch);
    const productPath = new URL(group.dataset.productUrl, location.origin).pathname;
    const url = swatch.dataset.url;

    group.querySelectorAll('.kleur-swatch').forEach((s) => {
      const on = s === swatch;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (scope) {
      const img = scope.querySelector(IMG_SELECTOR);
      if (img && swatch.dataset.img && img.getAttribute('src') !== swatch.dataset.img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = swatch.dataset.img;
      }
    }

    // Links in de kaart en een eventuele link om de hele kaart heen.
    const links = new Set(scope ? scope.querySelectorAll('a[href]') : []);
    for (let a = swatch.closest('a[href]'); a; a = a.parentElement && a.parentElement.closest('a[href]')) links.add(a);
    links.forEach((a) => {
      if (sameProduct(a.getAttribute('href'), productPath)) a.setAttribute('href', url);
    });
  }

  document.addEventListener(
    'mouseover',
    (e) => {
      const swatch = e.target.closest && e.target.closest('.kleur-swatch');
      if (swatch && canHover() && !swatch.classList.contains('is-active')) activate(swatch);
    },
    true
  );

  document.addEventListener(
    'focusin',
    (e) => {
      const swatch = e.target.closest && e.target.closest('.kleur-swatch');
      // Alleen toetsenbordfocus; bij een tik regelt de click-handler het.
      if (swatch && swatch.matches(':focus-visible') && !swatch.classList.contains('is-active')) activate(swatch);
    },
    true
  );

  // Capture-fase: vóór kaart-scripts en voordat een omringende <a> navigeert.
  document.addEventListener(
    'click',
    (e) => {
      const swatch = e.target.closest && e.target.closest('.kleur-swatch');
      if (!swatch) return;
      e.preventDefault();
      e.stopPropagation();
      // Touch: eerste tik kiest de kleur, tweede tik opent het product.
      if (!canHover() && !swatch.classList.contains('is-active')) {
        activate(swatch);
        return;
      }
      activate(swatch);
      window.location.href = swatch.dataset.url;
    },
    true
  );
})();
